

































































































import { Component, Prop } from "vue-property-decorator";
import { AgGridVue } from "ag-grid-vue";
import { ImportGrid } from "@/utils/grid/import-grid-helper";
import ImportGridFooter from "@/components/_shared/import-csv/import-grid-footer.vue";
import GridBoolComponent from "@/components/_shared/grid-components/grid-cells/grid-bool-component.vue";
import ImportGridHeader from "@/components/_shared/import-csv/import-grid-header.vue";
import { Company } from "@/interfaces/company";
import store from "@/stores/store";
import { UserRole } from "@/interfaces/user";
import { formValidation } from "@/utils/form-validation-helper";
import { Segment } from "@/interfaces/segment";
import { Warehouse } from "@/interfaces/warehouse";
import { companyApiProvider } from "@/providers/company-api-provider";
import router from "@/router/router";
import {MessageType} from "@/components/_shared/template/app-snackbar.vue";
import ImportGridReport from "@/components/_shared/import-csv/import-grid-report.vue";

@Component({
  name: "import-reception-csv-page",
  components: {
    ImportGridReport,
    ImportGridHeader,
    ImportGridFooter,
    AgGridVue,
    GridBoolComponent,
  },
})
export default class ImportReceptionCsvPage extends ImportGrid {
  @Prop() dataLabel: string;
  loading = true;
  rules = formValidation.getRules();

  // Select values.
  private userCompany: Company = store.getters["user/getUser"].company;
  private superAdmin = store.getters["user/getUser"].role == UserRole.superadmin;
  private warehouseSelect = store.getters["user/getUser"].warehouses;
  private companySelect: Company[] = [];

  // Import form data.
  private owner: Company | null = null;
  private warehouse: Warehouse | null = null;
  private segment: Segment | null = null;

  private reportData: object = null

  $refs: {
    importContactForm: HTMLFormElement;
  };

  // Société pour laquelle on importe : le client sélectionné pour un superadmin,
  // sinon la société de l'utilisateur connecté.
  get targetCompany(): Company | null {
    return this.superAdmin ? this.owner : this.userCompany;
  }

  // Le segment envoyé à l'api doit appartenir à la société importée, sinon il
  // ne peut pas être rattaché et il est perdu à l'enregistrement.
  get segmentSelect(): Segment[] {
    return this.targetCompany?.segments ?? [];
  }

  async beforeMount() {
    if (this.superAdmin) {
      this.companySelect = await companyApiProvider.getCompanies();
    }
    // Default values if only one choice exist
    this.updateSegmentSelection();
    if (this.$route.params.warehouseId) {
      this.warehouse =
        this.warehouseSelect.find(
          (value: Warehouse) => value.id == this.$route.params.warehouseId
        ) ?? null;
    } else if (this.warehouseSelect.length === 1) {
      this.warehouse = this.warehouseSelect[0];
    }
    // Report data
    this.reportData = null;

    await super.beforeMount();
  }

  async onValidate() {
    if (this.$refs.importContactForm.validate()) {
      this.reportData = null;
      const formData = new FormData();

      if (this.targetCompany) formData.append("owner", this.targetCompany.id);
      if (this.segment) formData.append("segment", this.segment.id);
      if (this.warehouse) formData.append("warehouse", this.warehouse.id);

      const response = await super.onValidate(formData, false);
      if (!response) return;
      const {data} = response;
      if (data && data.report) {
        // L'api peut renvoyer `result: "error"` sans ligne en erreur dans le rapport (ex. client manquant).
        if (data.result !== 'error' && !data.report.some(r => r.status === 'error')) {
          this.$eventHub.$emit("show-snackbar", { type: MessageType.success, mainText: this.$t("import_csv.success_snackbar") })
          await router.push(this.previousRoute);
          return;
        }

        if (!data.report.some(r => r.status === 'error')) {
          this.$eventHub.$emit("show-snackbar", { type: MessageType.error, mainText: this.$t("import_csv.error_snackbar") })
          return;
        }

        this.$eventHub.$emit("show-snackbar", { type: MessageType.warning, mainText: this.$tc("import_csv.incorrect_text", data.report.length) })
        this.reportData = data;
      }
    }
  }

  onClientChange() {
    this.warehouseSelect = this.owner.warehouses;
    // L'entrepôt et le segment précédents appartiennent à l'ancien client.
    if (
      this.warehouse &&
      !this.warehouseSelect.some((value: Warehouse) => value.id === this.warehouse.id)
    ) {
      this.warehouse = this.warehouseSelect.length === 1 ? this.warehouseSelect[0] : null;
    }
    this.updateSegmentSelection();
  }

  // Sélectionne le segment à envoyer à l'api. Le champ étant désactivé dès que la
  // société n'a qu'un segment (ou qu'il est imposé par la route), la valeur doit
  // être posée ici : sans ça `segment` reste null et n'est jamais envoyé.
  private updateSegmentSelection() {
    const segments = this.segmentSelect;
    // Segment imposé par la route.
    if (this.$route.params.segmentId) {
      this.segment =
        segments.find((value: Segment) => value.id == this.$route.params.segmentId) ?? null;
      return;
    }
    // Le segment sélectionné doit rester un segment de la société importée.
    if (this.segment && !segments.some((value: Segment) => value.id === this.segment.id)) {
      this.segment = null;
    }
    // Société mono segment => valeur par défaut (le champ est alors désactivé).
    if (!this.segment && segments.length === 1) {
      this.segment = segments[0];
    }
  }
}
